/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_A_Tag_And_Press_EnterInputs */

const en_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a tag and press Enter`)
};

const es_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una etiqueta y presiona Enter`)
};

const fr_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez un tag et appuyez sur Entrée`)
};

const de_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge ein Tag hinzu und drücke Enter`)
};

const ja_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグを追加してEnterキーを押す`)
};

const zh_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加标签后按回车键`)
};

const ar_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أضف علامة واضغط على إدخال`)
};

const id_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan tag dan tekan Enter`)
};

const it_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un tag e premi Invio`)
};

const ru_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавьте тег и нажмите Enter`)
};

const pt_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione uma tag e pressione Enter`)
};

const ko_add_a_tag_and_press_enter = /** @type {(inputs: Add_A_Tag_And_Press_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`태그를 추가하고 Enter를 누르세요`)
};

/**
* | output |
* | --- |
* | "Add a tag and press Enter" |
*
* @param {Add_A_Tag_And_Press_EnterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_a_tag_and_press_enter = /** @type {((inputs?: Add_A_Tag_And_Press_EnterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_A_Tag_And_Press_EnterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_a_tag_and_press_enter(inputs)
	if (locale === "es") return es_add_a_tag_and_press_enter(inputs)
	if (locale === "fr") return fr_add_a_tag_and_press_enter(inputs)
	if (locale === "de") return de_add_a_tag_and_press_enter(inputs)
	if (locale === "ja") return ja_add_a_tag_and_press_enter(inputs)
	if (locale === "zh") return zh_add_a_tag_and_press_enter(inputs)
	if (locale === "ar") return ar_add_a_tag_and_press_enter(inputs)
	if (locale === "id") return id_add_a_tag_and_press_enter(inputs)
	if (locale === "it") return it_add_a_tag_and_press_enter(inputs)
	if (locale === "ru") return ru_add_a_tag_and_press_enter(inputs)
	if (locale === "pt") return pt_add_a_tag_and_press_enter(inputs)
	return ko_add_a_tag_and_press_enter(inputs)
});